import ExportToExcel from '../../icons/ExportToExcel.tsx';
import { ApplicationReportsTable } from '~/components/ApplicationReports/components/table/ApplicationReportsTable.tsx';
import { Dispatch, SetStateAction, useState } from 'react';
import { errorMessages } from '~/constants/errorMessages.js';
import { useSelector } from 'react-redux';
import { Button, Grid } from '@mui/material';
import { styles } from '../styles.js';
import { getApplicationReportExcel } from '~/store/identification-form/thunks/applicationReportThunks.ts';
import { TApplicationReportsReportExcelForm } from '~/components/ApplicationReports/types.ts';
import { useAppDispatch } from '~/store/appDispatch.ts';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader';
import { setIdentificationError } from '~/store/identification-form/slices.ts';
import { selectIdentification } from '~/store/identification-form/selectors.ts';

interface INavigateGroup {
  params: {
    onIsRequestSuccessful: Dispatch<SetStateAction<boolean>>;
  };
  contentTable: string;
}

export const NavigateGroup = ({ params, contentTable }: INavigateGroup) => {
  const dispatch = useAppDispatch();

  const {
    applicationReportTable,
    applicationExportToExcel,
    loading: isLoading,
  } = useSelector(selectIdentification) || {};

  const [isResetData, setIsResetData] = useState(false);

  const { onIsRequestSuccessful } = params;

  const onClickIsRequestSuccessful = () => onIsRequestSuccessful(false);

  const handleExportToExcel = async () => {
    const form = (
      isResetData ? applicationReportTable : applicationExportToExcel
    ) as TApplicationReportsReportExcelForm;

    try {
      const res = await dispatch(getApplicationReportExcel({ form }));
      if (
        res.payload instanceof Blob &&
        res.payload.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        const url = window.URL.createObjectURL(res.payload);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `applications-report_${new Date().toISOString().split('T')[0]}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          dispatch(setIdentificationError({ errorMessage: errorMessages.SERVICE_UNAVAILABLE }));
        };
        reader.readAsText(res.payload as any);
      }
    } catch {
      dispatch(setIdentificationError({ errorMessage: errorMessages.SERVICE_UNAVAILABLE }));
    }
  };

  return (
    <>
      {!contentTable && (
        <Grid sx={styles.applicationReportsTable}>
          <Grid sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            <Button type="button" variant={'outlined'} onClick={onClickIsRequestSuccessful}>
              Назад
            </Button>
            <ExportToExcel onClick={handleExportToExcel} isDisabled={false} />
          </Grid>
          <ApplicationReportsTable setIsResetData={setIsResetData} />
        </Grid>
      )}

      {isLoading && <FullPageLoader />}
    </>
  );
};
